// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"yo-z","badgeLink":"zo-z","category":"Ao-z"};